import { useRef } from "react";
import equal from "fast-deep-equal/es6";

export function useDeepMemo<TValue>(memoFn: () => TValue, keys: any[]): TValue {
    const ref = useRef<{ keys: any[]; value: TValue }>();

    const { current: previous } = ref;

    if (!previous) {
        const value = memoFn();
        ref.current = { keys, value };
        return value;
    }

    if (keys.some((key, idx) => !equal(key, previous.keys[idx]))) {
        const value = memoFn();
        ref.current = { keys, value };
        return value;
    }

    return previous.value;
}
